import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ProductEnum } from '@uc/shared/data-models';
import {
	SourceTrackingTypes,
	FeaturedCalls,
	FeaturedRegisteredInterest,
	FeaturedClearing,
} from '@uc/web/shared/data-models';
import {
	CallUniBtnComponent,
	RegisterInterestBtnComponent,
	BookmarkComponent,
	ClearingVisitWebsiteBtnComponent,
} from '@web/shared/ui';

@Component({
	selector: 'uc-course-card-clearing-btns',
	standalone: true,
	templateUrl: './course-card-clearing-btns.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		NgClass,
		RegisterInterestBtnComponent,
		ClearingVisitWebsiteBtnComponent,
		BookmarkComponent,
		CallUniBtnComponent,
	],
})
export class CourseCardClearingBtnsComponent {
	sourceType = input.required<SourceTrackingTypes>();
	uniId = input.required<number>();
	uniName = input.required<string>();
	externalUrl = input.required<string>();
	phoneNumber = input.required<string | undefined | null>();
	isFeaturedCalls = input.required<FeaturedCalls>();
	isFeaturedRegisterInterest = input.required<FeaturedRegisteredInterest>();
	isFeatured = input.required<FeaturedClearing>();
	cleSearchOrderPosition = input.required<number>();
	academicYear = input.required<number>();
	privacyPolicyUrl = input.required<string | null>();
	version = input<'mobile' | 'desktop'>('mobile');
	isCourseSaved = input<boolean>(false);
	courseSlug = input<string>('');
	courseId = input<number>();
	courseName = input<string>('');

	showOnlyOneBtn = computed(() => {
		return (
			(!this.isFeaturedRegisterInterest() ||
				!this.phoneNumber() ||
				this.isFeaturedCalls()) &&
			!this.externalUrl()
		);
	});

	showTwoBtns = computed(() => {
		return (
			(this.isFeaturedRegisterInterest() ||
				(!!this.phoneNumber() && this.isFeaturedCalls())) &&
			!!this.externalUrl()
		);
	});

	showAllBtns = computed(() => {
		return (
			this.isFeaturedRegisterInterest() &&
			this.isFeaturedCalls() &&
			!!this.phoneNumber() &&
			!!this.externalUrl()
		);
	});

	showCallBtnOnDesktopIfNoRegisterInterest = computed(() => {
		return (
			(!this.isFeaturedRegisterInterest() || this.version() === 'desktop') &&
			this.isFeaturedCalls() &&
			!!this.phoneNumber()
		);
	});

	readonly clearing = ProductEnum.Clearing;
}
